import _ from 'lodash';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';

export function ColumnTruncatedText ({ text, options = {} }) {
    return (<Tooltip title={text || ''}><span>{_.truncate(text, _.defaultsDeep({}, options, _.defaultTruncateOptions))}</span></Tooltip>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    ColumnTruncatedText.displayName = 'ColumnTruncatedText';
}
